import locationTranslations from '@/common/constants/locationTraslations.constants';
import LOCATIONS_MAP from '@/common/constants/locationsMap.constants';

const locationNameKeys = Object.keys(locationTranslations);

const getInitialState = () => ({
  names: {
    [LOCATIONS_MAP.DISK]: 'disk',
    [LOCATIONS_MAP.HOST]: 'host',
    [LOCATIONS_MAP.RACK]: 'rack',
    [LOCATIONS_MAP.ROW]: 'row',
    [LOCATIONS_MAP.ROOM]: 'room'
  }
});

export default {
  name: 'locationNames',
  namespaced: true,
  state: getInitialState,
  getters: {
    getRoomTranslations: state => locationNameKeys.indexOf(state.names[LOCATIONS_MAP.ROOM]) !== -1
      ? locationTranslations[state.names[LOCATIONS_MAP.ROOM]]
      : locationTranslations.unknown(state.names[LOCATIONS_MAP.ROOM]),
    getRowTranslations: state => locationNameKeys.indexOf(state.names[LOCATIONS_MAP.ROW]) !== -1
      ? locationTranslations[state.names[LOCATIONS_MAP.ROW]] : locationTranslations.unknown(state.names[LOCATIONS_MAP.ROW]),
    getRackTranslations: state => locationNameKeys.indexOf(state.names[LOCATIONS_MAP.RACK]) !== -1
      ? locationTranslations[state.names[LOCATIONS_MAP.RACK]] : locationTranslations.unknown(state.names[LOCATIONS_MAP.RACK])
  },
  mutations: {
    SET_NAMES(state, names) {
      state.names = names;
    }
  },
  actions: {
    FETCH({ commit }) {
      this.$api.get('/api/v2/locations/configuration')
        .then(({ data }) => {
          commit('SET_NAMES', data.s.reduce((memo, item, index) => ({
            ...memo,
            [index]: item
          }), {}));
        });
    }
  }
};
